module.exports = __webpack_public_path__ + "img/SylviaRhue.36718097.jpg";